import Vue from 'vue';

// components
import ResizeHandler from "@/components/global_components/wrapper/ResizeHandler";

Vue.component('ResizeHandler', ResizeHandler);
